import { render } from "./Reference.layout.vue?vue&type=template&id=6c27bcdc"
import script from "./Reference.layout.vue?vue&type=script&lang=js"
export * from "./Reference.layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__